import type { TenantGroupDTO } from '../../types'
import { DataTable } from '../DataTable/DataTable'
import type { ColumnDef } from '../DataTable/DataTable'
import { formatDate } from '../../helpers/formatDate'
import { AvailabilityBadge } from '../AvailabilityBadge/AvailabilityBadge'
import type { TenantGroupsTableProps } from './TenantGroupsTable.types'

const columns: ColumnDef<TenantGroupDTO>[] = [
  {
    header: 'ID',
    sortValue: (g) => g.id,
    accessor: (g) => g.id,
    className: 'table-id-col text-end',
    cellClassName: 'font-monospace small',
  },
  {
    header: 'Code',
    sortValue: (g) => g.code,
    accessor: (g) => g.code,
    cellClassName: 'fw-medium',
  },
  {
    header: 'Name',
    sortValue: (g) => g.name,
    accessor: (g) => g.name,
  },
  {
    header: 'Type',
    sortValue: (g) => g.type,
    accessor: (g) => g.type,
  },
  {
    header: 'Availability Build',
    sortValue: (g) => g.availabilityBuildEnabled,
    accessor: (g) => <AvailabilityBadge enabled={g.availabilityBuildEnabled} />,
  },
  {
    header: 'Created',
    sortValue: (g) => g.createdAt,
    accessor: (g) => formatDate(g.createdAt),
  },
  {
    header: 'Updated',
    sortValue: (g) => g.updatedAt,
    accessor: (g) => formatDate(g.updatedAt),
  },
]

export function TenantGroupsTable({
  tenantGroups,
  onRowClick,
}: TenantGroupsTableProps) {
  return (
    <DataTable
      columns={columns}
      data={tenantGroups}
      rowKey={(g) => g.id}
      emptyMessage="No tenant groups found."
      onRowClick={onRowClick}
    />
  )
}
